exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th.sortable {\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/user/user-list/user-list.component.css
// module id = ../../../../../src/app/modules/user/user-list/user-list.component.css
// module chunks = main